import axios from "axios";

const TRACKING_ACTIVITY_URI_PREFIX = "/v1/tracking-activity";

const TRACKING_ACTIVITY_URIS = {
  GET_JOB_DETAIL: `${TRACKING_ACTIVITY_URI_PREFIX}/detail-job`,
  GET_ORDER_DETAIL: (id) =>
    `${TRACKING_ACTIVITY_URI_PREFIX}/${id}/order/detail`,
  GET_SHIPMENT_DETAIL: (id) =>
    `${TRACKING_ACTIVITY_URI_PREFIX}/${id}/shipment/detail`,
  UPDATE_STATUS: `${TRACKING_ACTIVITY_URI_PREFIX}/update-status`,
  GET_LIST_ACTIVITY_TRACKING: `${TRACKING_ACTIVITY_URI_PREFIX}/list`,
  GET_TDG_TRACKING_ACTIVITY: `${TRACKING_ACTIVITY_URI_PREFIX}/tdg-tracking-url`
};

export default {
  getJobDetailTrackingActivity(id, signal) {
    return axios.get(TRACKING_ACTIVITY_URIS.GET_JOB_DETAIL, {
      signal,
      params: {
        id,
      },
    });
  },
  getOrderDetailTrackingActivity(id, signal) {
    return axios.get(TRACKING_ACTIVITY_URIS.GET_ORDER_DETAIL(id), {
      signal,
    });
  },
  getShipmentDetailTrackingActivity(id, signal) {
    return axios.get(TRACKING_ACTIVITY_URIS.GET_SHIPMENT_DETAIL(id), {
      signal,
    });
  },
  updateStatusTrackingActivity: (params, signal) => {
    return axios.post(TRACKING_ACTIVITY_URIS.UPDATE_STATUS, null, {
      params,
      signal,
    });
  },
  getListActivityTracking(params, signal) {
    return axios.get(TRACKING_ACTIVITY_URIS.GET_LIST_ACTIVITY_TRACKING, {
      params,
      signal
    });
  },
  getListOrderActivityTracking(params) {
    return axios.get(TRACKING_ACTIVITY_URIS.GET_LIST_ACTIVITY_TRACKING, {
      params: { ...params, type: "order" },
    });
  },
  getListJobActivityTracking(params) {
    return axios.get(TRACKING_ACTIVITY_URIS.GET_LIST_ACTIVITY_TRACKING, {
      params: { ...params, type: "job" },
    });
  },
  getListShipmentActivityTracking(params) {
    return axios.get(TRACKING_ACTIVITY_URIS.GET_LIST_ACTIVITY_TRACKING, {
      params: { ...params, type: "shipment" },
    });
  },
  getShipmentStatusDetail(params) {
    return axios.get(
      `${TRACKING_ACTIVITY_URI_PREFIX}/${params.pId}/shipment-execute/detail`
    );
  },
  updateShipmentStatus(data) {
    return axios.post(`${TRACKING_ACTIVITY_URI_PREFIX}/shipment-status`, data);
  },
  getPODOrderSign(data) {
    return axios.get(
      `${TRACKING_ACTIVITY_URI_PREFIX}/orders/pod-signs/?orderId=${data}`
    );
  },
  getPODJobSign(data) {
    return axios.get(
      `${TRACKING_ACTIVITY_URI_PREFIX}/routes/pod-signs/?jobId=${data}`
    );
  },
  getPODDetailByStatus(params) {
    return axios.get(`${TRACKING_ACTIVITY_URI_PREFIX}/${params.id}/shipment/tracking`, { params });
  },
  getUserPermission() {
    return axios.get(
      `${TRACKING_ACTIVITY_URI_PREFIX}/order-status/check-permission`
    );
  },
  getTdgActivityTracking(routeId) {
    return axios.get(TRACKING_ACTIVITY_URIS.GET_TDG_TRACKING_ACTIVITY, {
      params: {"routeId": routeId}}
    );
  },
  getDriverTimeByRouteId(routeNo) {
    return axios.get(`${TRACKING_ACTIVITY_URIS.GET_JOB_DETAIL}/${routeNo}/driver-times`);
  }
};



// WEBPACK FOOTER //
// ./src/services/tracking-activity-service.js